import {
  getDaysOfMonthFromDaysOfWeek,
  getDaysOfMonthForL,
  getDaysOfMonthForW,
} from "./common";
// Helper functions for timezone handling
function getTimezoneOffset(timezone = "UTC") {
  const testDate = new Date();
  try {
    return new Intl.DateTimeFormat("en-US", {
      timeZone: timezone,
      timeZoneName: "short",
    }).resolvedOptions().timeZone === timezone
      ? testDate.getTimezoneOffset()
      : 0;
  } catch {
    return 0; // Default to UTC if timezone is invalid
  }
}

function adjustToTimezone(date, timezone = "UTC") {
  const offset = getTimezoneOffset(timezone);
  return new Date(date.getTime() + offset * 60 * 1000);
}

// Main functions converted from TypeScript
let iter;

const findOnce = function(parsed, from, timezone = "UTC") {
  if (iter > 10) {
    throw new Error("AwsCronParser : this shouldn't happen, but iter > 10");
  }
  iter += 1;

  //   const adjustedDate = adjustToTimezone(from, timezone);
  const adjustedDate = from;
  const cYear = adjustedDate.getFullYear();
  const cMonth = adjustedDate.getMonth() + 1;
  const cDayOfMonth = adjustedDate.getDate();
  const cHour = adjustedDate.getHours();
  const cMinute = adjustedDate.getMinutes();

  const year = parsed.years.find((c) => c >= cYear);
  if (!year) {
    return null;
  }

  const month = parsed.months.find((c) => c >= (year === cYear ? cMonth : 1));
  if (!month) {
    return findOnce(
      parsed,
      new Date(new Date(year + 1, 0).getTime()),
      timezone
    );
  }

  const isSameMonth = year === cYear && month === cMonth;
  let pDaysOfMonth = parsed.daysOfMonth;
  if (pDaysOfMonth.length === 0) {
    pDaysOfMonth = getDaysOfMonthFromDaysOfWeek(year, month, parsed.daysOfWeek);
  } else if (pDaysOfMonth[0] === "L") {
    pDaysOfMonth = getDaysOfMonthForL(year, month, pDaysOfMonth[1]);
  } else if (pDaysOfMonth[0] === "W") {
    pDaysOfMonth = getDaysOfMonthForW(year, month, pDaysOfMonth[1]);
  }

  const dayOfMonth = pDaysOfMonth.find(
    (c) => c >= (isSameMonth ? cDayOfMonth : 1)
  );
  if (!dayOfMonth) {
    return findOnce(
      parsed,
      new Date(new Date(year, month + 1 - 1).getTime()),
      timezone
    );
  }

  const isSameDate = isSameMonth && dayOfMonth === cDayOfMonth;
  const hour = parsed.hours.find((c) => c >= (isSameDate ? cHour : 0));
  if (typeof hour === "undefined") {
    return findOnce(
      parsed,
      new Date(new Date(year, month - 1, dayOfMonth + 1).getTime()),
      timezone
    );
  }

  const minute = parsed.minutes.find(
    (c) => c >= (isSameDate && hour === cHour ? cMinute : 0)
  );
  if (typeof minute === "undefined") {
    return findOnce(
      parsed,
      new Date(new Date(year, month - 1, dayOfMonth, hour + 1).getTime()),
      timezone
    );
  }

  return new Date(
    new Date(year, month - 1, dayOfMonth, hour, minute).getTime()
  );
};

/**
 * Generate the next occurrence AFTER the "from" date value
 * returns NULL when there is no more future occurrence
 * @param {Object} parsed - the value returned by "parse" function of this module
 * @param {Date} from - the Date to start from
 * @param {string} [timezone='UTC'] - Optional IANA timezone string
 */
export function next(parsed, from, timezone = "UTC") {
  // iter is just a safety net to prevent infinite recursive calls
  // because I'm not 100% sure this won't happen
  iter = 0;
  return findOnce(
    parsed,
    new Date((Math.floor(from.getTime() / 60000) + 1) * 60000),
    timezone
  );
}
